var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpand = function SvgExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 3.6h.6v1.2H4.8v4.8H3.6v-6H9M3.6 15v-.6h1.2v4.8h4.8v1.2h-6V15M19.8 3.6h.6v6h-1.2V4.8h-4.8V3.6h5.4M19.2 15v-.6h1.2v6h-6v-1.2h4.8z"
  })));
};
export default SvgExpand;